"use client";

import { useSession } from "next-auth/react";
import { useTranslations } from "next-intl";

import { Accordion } from "@/common/components/accordion";
import { useMe } from "@/features/account/hooks/use-me";
import { MarkupCalculatorForm } from "./markup-calculator-form";

export function MarkupCalculator() {
  const t = useTranslations("common");
  const session = useSession();
  const { data: customer } = useMe(session.data);

  if (!customer?.custom?.fields?.showMarkupCalculator) return null;

  const markupDefault = customer?.custom?.fields?.markupCalculatorDefault;

  return (
    <Accordion
      id="markup"
      items={[
        {
          title: t("text-markup-calculator"),
          content: <MarkupCalculatorForm markupDefault={markupDefault} />,
        },
      ]}
    />
  );
}
